<template>
    <div class="continer">
        <pageHeader isCustom>
            <div class="logout-btn"  @click="logout">退出登录</div>
        </pageHeader>
        <background>
            <div class="content">
                <img class="finish-icon" src="@/assets\images\busImage\check_circle.png" >
                <div class="success-text">上传成功</div>
                <div class="tips-text">您可在“玖元AI平台 图片管理”中，查看结果</div>
                <div class="btn-group-list">
                    <div class="back-btn" @click="goBack">返回</div>
                    <div class="continue-btn" @click="goScan">继续扫描</div>
                </div>
            </div>
        </background>
        <tipsDialog  :tipsMessage="`入库成功，纸仓已满，无法继续制单，将在${countDownNum}秒后退出登录`"
                     :dialogVisible="dialogVisible">
        </tipsDialog>
    </div>
</template>

<script>
import pageHeader from './components/pageHeader'
import background from '@/components/background'
import tipsDialog from '@/components/tipsDialog'
import scanMixin from '@/mixin/scanMixin'
import {uploadLogs} from '@/api/user'
export default {
    components: { pageHeader,background,tipsDialog },
    mixins: [scanMixin],
    data(){
        return {
            dialogVisible:false
        }
    },
    mounted(){
        this.handleRetain()
    },
    methods: {
        goBack(){
            this.$router.push({name: 'start'})
        },
        goScan(){
            this.$router.push({name: 'fileWaitScan'})
        },
        // 处理文件存入纸仓
        handleRetain(){
            this.retain().then(res => {
                 this.finishStore = true
            }).catch(e => {
                if(e.status === -11){
                    this.dialogVisible = true
                    this.handleCountDown()
                }
            })
        },
         // 纸仓满退出登录流程
        handleCountDown(){
            let remainingSeconds = 15;
            this.countDownNum = remainingSeconds
            let that =  this
            this.timerId = setInterval(function() {
                if (remainingSeconds === 0) {
                    clearInterval(that.timerId);
                    that.dialogVisible = false
                    that.$store.dispatch('LogOut').then(() => {
                        that.$router.push({name: 'login',query:{status: 11}})
                    })
                } else {
                    that.countDownNum = remainingSeconds
                    remainingSeconds--;
                }
            }, 1000);
        },
        logout(){
            uploadLogs({
                content: '按钮触发，主动退出',
                errorCode: 0,
                module: '退出登录'
            }).catch(e => {})
            this.$store.dispatch('LogOut').then(() => {
                this.$router.push({name: 'login'})
            })
        },
    }
}
</script>

<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
    }
    .logout-btn {
        position: absolute;
        padding: 17px 22px;
        top: 42px;
        right: 40px;
        background: rgba(239,239,239,0.5);
        border-radius: 8px;
        font-size: 32px;
        text-align: center;
        color: #FFFFFF;
    }
    .content {
        position: absolute;
        top: 300px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .finish-icon {
            height: 60px;
            width: 60px;
        }
        .success-text {
            font-size: 32px;
            font-weight: bold;
            color: #F7636E;
            margin: 30px 0;
        }
        .tips-text {
            font-size: 28px;
        }
        .btn-group-list {
            margin: 100px;
            text-align: center;
            .back-btn {
                height: 70px;
                line-height: 70px;
                width: 200px;
                background: #FFFFFF;
                border: #B23B34 1px solid;
                border-radius: 8px;
                font-weight: 400;
                font-size: 28px;
                color: #B23B34;
                margin-bottom: 30px;
            }
            .continue-btn {
                height: 70px;
                line-height: 70px;
                width: 200px;
                background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
                border-radius: 8px;
                font-weight: 400;
                font-size: 28px;
                color: #FFFFFF;
            }
        }
        
    }
</style>
